@import "config";

.wizard {
	@mixin change-item-color($color, $svg-color, $background) {
		.item {
			span {
				color: $color;
			}

			path:first-of-type {
				stroke: $svg-color;
			}

			.tag {
				@extend .tag;
				background: $background;

				path:first-of-type {
					stroke: $svg-color;
					fill: $svg-color;
				}
			}
		}
	}

	@include flex(row, space-between, center);

	width: 100%;
	background-color: $color-light-l4;
	padding: $spacing-inset-xs;
	border-radius: $border-radius-sm;
	margin-bottom: $spacing-inline-xxxs;

	&.spread {
		padding: $spacing-inset-xs $spacing-inset-quarck;
		ul {
			justify-content: space-around;
		}
	}

	&.clicky {
		ul > li {
			&:not(.current) {
				cursor: pointer;
			}
		}
		ul > li:hover {
			&:not(.current) {
				@include change-item-color($color-dark-d3, $color-dark-d3, $color-success-light);
			}
		}
	}

	ul {
		@include flex(row, space-between, center);
		width: 100%;
		list-style-type: none;
		padding-left: 0;
		margin-bottom: 0;
		user-select: none;

		li {
			@include flex(row, unset, center);
			margin-bottom: 4px;

			&:not(:last-child) {
				margin-right: $spacing-inline-xxxs;
			}

			span {
				color: $color-dark-d4;
				margin-right: $spacing-inline-quarck;
				margin-left: $spacing-inline-nano;
				font-size: $font-size-xxs;
				font-weight: $font-weight-bold;
			}

			.item {
				@include flex(row, unset, center);

				span {
					color: $color-dark-d1;
					font-weight: $font-weight-bold;
				}

				.tag {
					@include flex(row, center, center);
					width: 20px;
					height: 20px;
					shape-outside: circle();
					clip-path: circle();
					font-size: $font-size-xxs;
					font-weight: $font-weight-bold;
					background: $color-light-l1;
					color: $color-light-l5;
				}
			}

			&.previous {
				@include change-item-color(
					$color-success-darkest,
					$color-success-medium,
					$color-success-lightest
				);
			}

			&.current {
				@include change-item-color(
					$color-primary-pure,
					$color-primary-pure,
					$color-primary-pure
				);
			}
		}
	}

	.stepsWithoutTitle {
		justify-content: center;

		li {
			&:not(:last-child) {
				margin-right: $spacing-inline-quarck;
			}

			.item {
				.tag {
					margin-right: $spacing-inline-quarck;
				}
			}
		}
	}
}
